const className = 'html-overflow-hidden'

export function toggleOverflow(isOpen: boolean): void {
  if (isOpen) {
    document.body.classList.add(className)
  } else {
    document.body.classList.remove(className)
  }
}
